import { render, staticRenderFns } from "./ParticipantCategory.vue?vue&type=template&id=d34c5b6c&"
import script from "./ParticipantCategory.vue?vue&type=script&lang=js&"
export * from "./ParticipantCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports